// extracted by mini-css-extract-plugin
export default {"TextLabel":"TextLabels__TextLabel___ocQfF","mediumGrey":"TextLabels__mediumGrey___Jo510","darkGrey":"TextLabels__darkGrey___k5T5f","strong":"TextLabels__strong___CtBB6"};